// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2NFd5","empty":"ModalGraph_empty__2STTR"};